import { Button, Checkbox, Col, Row, Space, Typography } from "antd";
import React, { useState, useMemo } from "react";
import "./ChatTerms.css";
import { ReactComponent as ShieldCheck } from "../../../assests/shield-check.svg";
import { useDispatch, useSelector } from "react-redux";
import { setAllowChat } from "../../../store/slices/common-slice/chat-communication/ChatCommunicationActionItems";
import { postUserProfile } from "../../../store/thunks/common-thunks/commonThunk";

const { Text } = Typography;

const ChatTerms = () => {
  const dispatch = useDispatch();

  const { allowChat } = useSelector(
    (state) => state.chatCommunicationHandleSlice
  );

  const { chatsMonitered, professionalGuidelines, userId } = useSelector(
    (state) => state.userprofile
  );

  // Local checkbox state
  const [isMonitoredChecked, setIsMonitoredChecked] = useState(false);
  const [isGuidelinesChecked, setIsGuidelinesChecked] = useState(false);

  /**
   * Button enable logic
   */
  const isAcceptEnabled = useMemo(() => {
    return isMonitoredChecked && isGuidelinesChecked;
  }, [isMonitoredChecked, isGuidelinesChecked]);

  const handleAcceptChat = () => {
    if (!isAcceptEnabled) return;

    dispatch(
      postUserProfile({
        mongo_id: userId,
        chats_monitored: true,
        professional_guidelines: true,
      })
    );
    dispatch(setAllowChat(true));
  };

  return (
    <div className="chat-terms-container">
      <Row justify="center">
        <ShieldCheck className="chat-terms-icon" />
      </Row>

      <Row justify="center" className="chat-terms-title">
        <Text className="chat-term-text">Chat Terms</Text>
      </Row>

      <Row justify="center" className="chat-terms-title">
        <Text className="quick-review-text">Quick review before chatting</Text>
      </Row>

      <Row className="chat-terms-content">
        <div className="monitored-transparency-div">
          <Row>
            <Text className="retrictions-text">Monitored for Transparency</Text>
          </Row>
          <Row>
            <Text
              className="restiction-rules-text"
              style={{ paddingInline: 15 }}
            >
              All chats are monitored by AMP for quality and compliance. This
              protects both buyers and sellers.
            </Text>
          </Row>
        </div>
      </Row>

      <Row className="chat-terms-content" gutter={[16, 16]}>
        <Col span={12}>
          <div className="dos-div">
            <Text className="retrictions-text">Do's</Text>
            <ul className="restiction-rules-text">
              <li>Be Professional</li>
              <li>Ask product questions</li>
              <li>Discuss pricing</li>
            </ul>
          </div>
        </Col>

        <Col span={12}>
          <div className="donts-div">
            <Text className="retrictions-text">Don'ts</Text>
            <ul className="restiction-rules-text">
              <li>Share personal info</li>
              <li>Off-platform deals</li>
              <li>Inappropriate talk</li>
            </ul>
          </div>
        </Col>
      </Row>

      <Space
        style={{ width: "100%", marginTop: 25 }}
        direction="vertical"
        size={15}
      >
        <Row>
          <Checkbox
            checked={isMonitoredChecked}
            onChange={(e) => setIsMonitoredChecked(e.target.checked)}
            // disabled={chatsMonitered}
          >
            <Text className="chat-terms-checkbox">
              I understand chats are <strong>monitored by AMP</strong>
            </Text>
          </Checkbox>
        </Row>

        <Row>
          <Checkbox
            checked={isGuidelinesChecked}
            onChange={(e) => setIsGuidelinesChecked(e.target.checked)}
            // disabled={professionalGuidelines}
          >
            <Text className="chat-terms-checkbox">
              I will follow <strong>Professional Guidelines</strong>
            </Text>
          </Checkbox>
        </Row>

        <Row>
          <Button
            className="accept-chat-btn"
            disabled={!isAcceptEnabled}
            onClick={handleAcceptChat}
          >
            <Text className="accept-chat-txt">Accept & Start Chat</Text>
          </Button>
        </Row>

        <Row justify="center">
          <Button type="link">
            <Text className="terms-chat-link">Terms & Conditions</Text>
          </Button>
        </Row>
      </Space>
    </div>
  );
};

export default ChatTerms;
